import { useEffect, useState } from 'react'

import {
  EndBenefitExpiredSubscriptionRequest,
  companyIsActiveButWithExpiredSubscription,
  endBenefitExpiredSubscriptions,
} from 'core'

import { Alert, Col, ConfirmButton, Notification, Row } from 'common/components'
import { useCommandRequestV2, useLoginUserV2, useQueryRequestV2 } from 'common/hooks'

type Props = {
  companyId: string
  productId: number
}

const SubscriptionExpiredInfo = (props: Props) => {
  const { user } = useLoginUserV2()

  const { data: activeButWithExpiredSubscription } = useQueryRequestV2({
    queryFn: () =>
      companyIsActiveButWithExpiredSubscription({ companyId: props.companyId, productId: props.productId }),
    initialState: undefined,
  })

  const [isVisible, setIsVisible] = useState<boolean>(false)

  useEffect(() => {
    setIsVisible(activeButWithExpiredSubscription != undefined && activeButWithExpiredSubscription)
  }, [activeButWithExpiredSubscription])

  const { isLoading: isCommandLoading, sendCommand } = useCommandRequestV2(
    (request: EndBenefitExpiredSubscriptionRequest) => endBenefitExpiredSubscriptions(request),
  )

  const onConfirm = async () => {
    const result = await sendCommand({
      companyId: props.companyId,
      productId: props.productId,
    })

    if (result.completed) {
      Notification.success('Subscription deactivated')
      setIsVisible(false)
    }
  }

  return (
    <>
      {isVisible && (
        <Alert
          message={'Subscription expired'}
          className={'mb-16'}
          type={'error'}
          description={
            <Row>
              <Col span={24} className={'mb-8'}>
                This company has an active account on our app but is not paying on RECURLY.
              </Col>
              {user.canDeactivateCompany && (
                <Col>
                  <ConfirmButton
                    loading={isCommandLoading}
                    disabled={isCommandLoading}
                    confirmModalTitle={'Deactivate subscription?'}
                    onConfirm={onConfirm}
                  >
                    Deactivate
                  </ConfirmButton>
                </Col>
              )}
            </Row>
          }
        />
      )}
    </>
  )
}

export default SubscriptionExpiredInfo
